import { createPresignedUploadTask } from '../upload-media';
import { useMediaUploadUrl } from '../use-media-upload-url';
import { UploadsOpts, useUploads } from '../use-uploads';

export const useUserUploads = (opts?: UploadsOpts) => {
  const getUploadUrl = useMediaUploadUrl();

  return useUploads(
    ({ key, file, onProgress }) =>
      createPresignedUploadTask({ getUploadUrl, key, file, onProgress }),
    opts,
  );
};
